/** Adapted from ph-zgss/src/ui/utils.js for ph-savezi address shape (postal, not postal_code). */

export type AddressLike = {
  street?: string;
  postal?: string;
  city?: string;
  county?: string;
};

export function hasNonEmpty(value: unknown): value is string {
  return typeof value === "string" && value.trim().length > 0;
}

export function hasPhoneContact(
  contact: { phone?: string; mobile?: string; fax?: string } | null | undefined,
): boolean {
  if (!contact) return false;
  return (
    hasNonEmpty(contact.phone) ||
    hasNonEmpty(contact.mobile) ||
    hasNonEmpty(contact.fax)
  );
}

/** Strip spaces and normalize international prefix for tel: URLs. */
export function formatPhoneForTel(phone: string | undefined | null): string {
  if (phone == null || phone === "") return "";
  return String(phone).replace(/\s+/g, "").replace(/^00/, "+");
}

const PHONE_SPLITTERS = /[,;/|]|\s+i\s+|\n+/i;

export function splitPhoneParts(raw: string | undefined | null): string[] {
  if (raw == null) return [];
  return String(raw)
    .split(PHONE_SPLITTERS)
    .map((p) => p.trim())
    .filter(Boolean);
}

/**
 * When multiple numbers are present (comma, slash, " i "), use the first dialable segment.
 */
export function firstPhoneSegment(
  raw: string | undefined | null,
): string | null {
  const parts = splitPhoneParts(raw);
  return parts[0] ?? null;
}

export function generateGoogleMapsSearchUrl(
  address: AddressLike | null | undefined,
): string | null {
  if (!address) return null;
  const parts: string[] = [];
  if (hasNonEmpty(address.street)) parts.push(address.street!.trim());
  if (hasNonEmpty(address.postal)) parts.push(address.postal!.trim());
  if (hasNonEmpty(address.city)) parts.push(address.city!.trim());
  if (hasNonEmpty(address.county)) parts.push(address.county!.trim());
  if (parts.length === 0) return null;
  const query = encodeURIComponent(parts.join(", "));
  return `https://www.google.com/maps/search/?api=1&query=${query}`;
}
